import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Approved, Specification, sendEmailmultiple } from 'src/app/service/modal/approved';
import { TrashService } from 'src/app/service/apiservice/trash.service';
import { PendingRequestService } from '../../../service/apiservice/pendingrequest.service';
import { Sub, Remark } from '../../../service/modal/pendingrequest';
import { ApprovedService } from '../../../service/apiservice/approved.service';
import { Globals } from '../../../globals';
import { Router } from '@angular/router';
import { NgForm, Validators, FormControl, AbstractControl, FormGroup, FormBuilder } from '@angular/forms';
declare var $;
declare function info_noti(msg: any): any;
@Component({
  selector: 'app-trash-hc',
  templateUrl: './trash-hc.component.html',
  styleUrls: ['./trash-hc.component.css']
})
export class TrashHcComponent implements OnInit {

  trashGrid: Approved[] = new Array();
  trashViewData: Approved = new Approved();

  addApprovedHealthCard: Approved = new Approved();
  @ViewChild('addForm') addForm: any;
  @ViewChild('AddCloseForm') addCloseForm: ElementRef;

  //subject DropDown//
  subjectDropDown: any;
  subjectDropDown_SelectedId: number[];
  //subject DropDown//

  //Specification DropDown//
  specificationDropDown: any;
  specificationDropDown_SelectedId: number[];
  //Specification DropDown//
  hoveredIndex;
  //Remark DropDown//
  remarkDropDown: any;
  remarkDropDown_SelectedId: number[];
  //Remark DropDown//
  eyeIcon: string = "zmdi-eye-off";
  starIcon: string = "zmdi-star-outline";

  todayDate: any;
  showActions: boolean = false;
  selectedMailList = [];

  approvedObjActionShow = new Approved();
  checkClickCount = 0;

  selectedActionList: Approved[] = new Array();;
  appvar: Approved;

  //multiple email forward
  emailId;
  sendEmailmultiple = new sendEmailmultiple;
  constructor(private fb: FormBuilder,private router: Router, private _approvedService: ApprovedService, private _trashService: TrashService, private chRef: ChangeDetectorRef, private _pendingRequestService: PendingRequestService, private global: Globals) { }

  ngOnInit() {
    localStorage.setItem("Active Route", this.router.url);
    this.global.afterRefreshPageSetToken();
    this.GetTrash_Grid();
    this.todayDate = new Date();
    $(".modal-wide").on("show.bs.modal", function () {
      var height = $(window).height() - 80;
      $(this).find(".modal-body").css("max-height", height);
    });
    this.loadSendEmailForm();
  }
  //DropDown Functions//
  subjectDropDown_Added = (term) => ({ subjectId: term, name: term });
  specificationDropDown_Added = (term) => ({ specificationId: term, name: term });
  remarkDropDown_Added = (term) => ({ remarkId: term, name: term });
  //DropDown Functions//
  GetTrash_Grid() {
    this._trashService.GetTrashList()
      .subscribe((response) => {
        if ($.fn.dataTable.isDataTable('#trashDatatable')) {
          $('#trashDatatable').dataTable().fnClearTable();
          $('#trashDatatable').dataTable().fnDestroy();
        }

        if ($.fn.dataTable.isDataTable('#trashDatatable_IsMobile')) {
          $('#trashDatatable_IsMobile').dataTable().fnClearTable();
          $('#trashDatatable_IsMobile').dataTable().fnDestroy();
        }

        Object.assign(this.trashGrid, response);
        this.trashGrid.forEach((element) => {

          if (element.sub.length == 0) {
            element.subBindGrid = "";
          } else {
            element.sub.forEach((elem) => {
              if (element.subBindGrid == undefined) {
                element.subBindGrid = elem.name
              }
              else {
                element.subBindGrid = element.subBindGrid + ',' + elem.name;
              }
              // element.subBindGrid="";
            })
          }
          if (element.spec.length == 0) {
            element.specBindGrid = "";
          } else {
            element.spec.forEach((elem) => {
              if (element.specBindGrid == undefined) { element.specBindGrid = elem.name }
              else { element.specBindGrid = element.specBindGrid + ',' + elem.name; }
            })
          }
          if (element.remark.length == 0) {
            element.remarkBindGrid = "";
          } else {
            element.remark.forEach((elem) => {
              if (element.remarkBindGrid == undefined) { element.remarkBindGrid = elem.name }
              else { element.remarkBindGrid = element.remarkBindGrid + ',' + elem.name; }
            })
          }
        });
        this.chRef.detectChanges();
        $("#trashDatatable").DataTable({
          "paging": false,
          "info": false,
          "order": [[8, 'desc']],
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
        });
        $("#trashDatatable_filter").hide();
        $("#trashDatatable_IsMobile").DataTable({
          "paging": false,
          "info": false,
          "order": [[3, 'desc']],
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
        });
        $("#trashDatatable_IsMobile_filter").hide();
      },
        error => {
        })
  }

  checkYear(data): Boolean {
    let userDate = new Date(data);
    if (userDate.getFullYear() == this.todayDate.getFullYear()) {
      return true;
    }
    else {
      return false;
    }
  }

  ViewDataBind(data: Approved) {
    console.log(data);
    Object.assign(this.trashViewData, data);
  }

  //Add approved

  Add_PreDataBind() {

    //Subject Dropdown
    this._pendingRequestService.GetAllSubject()
      .subscribe((response) => {
        this.subjectDropDown = response;
        console.log(response);
      },
        error => {
          console.log(error);
        })

    //Specification Dropdown
    this._pendingRequestService.GetAllSpecification()
      .subscribe((response) => {
        this.specificationDropDown = response;
        console.log(response);
      },
        error => {
          console.log(error);
        })

    //Specification Dropdown
    this._pendingRequestService.GetAllRemark()
      .subscribe((response) => {
        this.remarkDropDown = response;
        console.log(response);
      },
        error => {
          console.log(error);
        })
  }

  ApprovedHealthSubmit() {
    debugger;
    //sub data
    var localsub: Sub[] = new Array();
    for (let data of this.subjectDropDown_SelectedId) {
      if (isNaN(data)) {
        var newSub: Sub = {
          subjectId: 0,
          name: data.toString(),
        }
        localsub.push(newSub);
      }
      else {
        var oldSub: Sub = {
          subjectId: data,
          name: this.subjectDropDown.find(a => a.subjectId == data).name,
        }
        localsub.push(oldSub);
      }
    }

    //spec data
    var localspec: Specification[] = new Array();
    for (let data of this.specificationDropDown_SelectedId) {
      if (isNaN(data)) {
        var newSpec: Specification = {
          specificationId: 0,
          name: data.toString(),
        }
        localspec.push(newSpec);
      }
      else {
        var oldSpec: Specification = {
          specificationId: data,
          name: this.specificationDropDown.find(a => a.specificationId == data).name,
        }
        localspec.push(oldSpec);
      }
    }

    //remark data
    var localrmk: Remark[] = new Array();
    for (let data of this.remarkDropDown_SelectedId) {
      if (isNaN(data)) {
        var newRmk: Remark = {
          remarkId: 0,
          name: data.toString(),
        }
        localrmk.push(newRmk);
      }
      else {
        var oldRmk: Remark = {
          remarkId: data,
          name: this.remarkDropDown.find(a => a.remarkId == data).name,
        }
        localrmk.push(oldRmk);
      }
    }

    this.addApprovedHealthCard.sub = localsub;
    this.addApprovedHealthCard.spec = localspec;
    this.addApprovedHealthCard.remark = localrmk;

    this._approvedService.AddApproved_HealthCard(this.addApprovedHealthCard)
      .subscribe((response) => {
        this.addForm.resetForm();
        this.addCloseForm.nativeElement.click();
        this.GetTrash_Grid();
      },
        error => {
          info_noti(error);
        })
  }
  Add_CloseClick() {
    this.addForm.resetForm();
  }
  addCancelClick() {
    this.addForm.resetForm();
  }
  Eye_Click() {
    this.eyeIcon = this.eyeIcon == "zmdi-eye" ? "zmdi-eye-off" : "zmdi-eye";
    this.addApprovedHealthCard.hide = this.eyeIcon == "zmdi-eye" ? true : false;
  }

  Star_Click() {
    this.starIcon = this.starIcon == "zmdi-star" ? "zmdi-star-outline" : "zmdi-star";
    this.addApprovedHealthCard.star = this.starIcon == "zmdi-star" ? true : false;
  }






  // checkboxChanged(event) {
  //   if (event.target.checked) {
  //     this.selectedMailList.push(event.target.value);
  //   }
  //   else {
  //     this.selectedMailList.splice(this.selectedMailList.indexOf(event.target.value), 1);
  //   }
  //   this.selectedMailList=Array.from(new Set(this.selectedMailList));

  //   if(this.selectedMailList.length>0){
  //     this.showActions = true;
  //   }
  //   else{this.showActions = false;

  //   }
  // }
  checkboxChanged(event, obj, status, allSelectedList, type) {
    debugger;
    if (type == "mobile") {
      if (status == "selectAll") {
        if (event.target.checked) {
          var i = 1;
          allSelectedList.forEach(element => {
            this.selectedMailList.push(element.appEmailId);
            $('#checkboxm' + i).prop("checked", true);
            i++;
          })
        } else {

          var i = 1;

          allSelectedList.forEach(element => {
            this.selectedMailList.splice(this.selectedMailList.indexOf(element.appEmailId, 1));

            $('#checkboxm' + i).prop("checked", false);
            i++;
          })
        }

      } else {

        if (event.target.checked) {
          this.selectedMailList.push(obj.appEmailId);
          if (this.selectedMailList.length == this.trashGrid.length) {
            $('#selectAllm').prop("checked", true);
          }

        }
        else {
          $('#selectAllm').prop("checked", false);
          this.selectedMailList.splice(this.selectedMailList.indexOf(obj.appEmailId), 1);
        }
      }
      this.selectedMailList = Array.from(new Set(this.selectedMailList));

      if (this.selectedMailList.length > 0) {
        this.showActions = true;
        if (this.checkClickCount == 0) {
          this.checkClickCount = 1;
          this.approvedObjActionShow = obj;
        }
      }
      else {
        this.checkClickCount = 0;
        this.approvedObjActionShow = null;
        this.showActions = false;
      }
    } else {
      if (status == "selectAll") {
        if (event.target.checked) {
          var i = 1;
          allSelectedList.forEach(element => {
            this.selectedMailList.push(element.appEmailId);
            $('#checkbox' + i).prop("checked", true);
            i++;
          })
        } else {

          var i = 1;

          allSelectedList.forEach(element => {
            this.selectedMailList.splice(this.selectedMailList.indexOf(element.appEmailId, 1));

            $('#checkbox' + i).prop("checked", false);
            i++;
          })
        }

      } else {

        if (event.target.checked) {
          this.selectedMailList.push(obj.appEmailId);
          if (this.selectedMailList.length == this.trashGrid.length) {
            $('#selectAll').prop("checked", true);
          }

        }
        else {
          $('#selectAll').prop("checked", false);
          this.selectedMailList.splice(this.selectedMailList.indexOf(obj.appEmailId), 1);
        }
      }
      this.selectedMailList = Array.from(new Set(this.selectedMailList));

      if (this.selectedMailList.length > 0) {
        this.showActions = true;
        if (this.checkClickCount == 0) {
          this.checkClickCount = 1;
          this.approvedObjActionShow = obj;
        }
      }
      else {
        this.checkClickCount = 0;
        this.approvedObjActionShow = null;
        this.showActions = false;
      }
    }

  }




  multipleUndo(flag: boolean) {
    debugger;
    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.selectedActionList[i] = this.appvar;

    }
    this._trashService.TrashUndoMultiple(this.selectedActionList).subscribe((response) => {
      info_noti("Undo Success...");
      this.GetTrash_Grid();
      this.selectedMailList.length = 0;
      this.appvar = new Approved();
      this.selectedActionList.length = 0;

      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        this.showActions = false;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
    }, error => { info_noti(error); }
    );
    console.log(this.selectedMailList);
  }



  enteredEmailIDForForwordEmail(emailId) {
    this.emailId = emailId;
  }

	  
  multipleForword(emailId,form:NgForm) {
    if (emailId != "") {
      $("#multipleForwordBtn").attr("disabled", true);
      for (var i = 0; i < this.selectedMailList.length; i++) {
        this.appvar = new Approved();
        this.appvar.appEmailId = Number(this.selectedMailList[i]);
        this.selectedActionList[i] = this.appvar;
      }
      
      this.sendEmailmultiple.approved = this.selectedActionList;
      // this.sendEmailmultiple.emailid = emailId;
      
      this.sendEmailmultiple.emailid = this.sendEmailForm.controls['toAddress'].value;
      
    
      this._approvedService.forwordMultiple(this.sendEmailmultiple).subscribe((response) => {
        info_noti("Email Send Success...");
        $("#multipleForwordBtn").attr("disabled", false);
        $('#sendForwordemail').val('');
        $("#sendEmailForMultipleForword").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
        this.selectedMailList.length = 0;
        
        this.selectedActionList.length = 0;
        if (this.selectedMailList.length > 0) {
          this.showActions = true;
        }
        else {
          this.approvedObjActionShow = null;
          this.showActions = false;
          this.checkClickCount = 0;
          this.sendEmailmultiple = new sendEmailmultiple;
        }
        $('#selectAll').prop("checked", false);
        $('#selectAllm').prop("checked", false);
        this.GetTrash_Grid();
       
       
      }, error => {
        info_noti("Email Not send");
       
        $("#sendEmailForMultipleForword").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
      }
      );
      console.log(this.selectedMailList);
    } else {
      this.emailId = '';
      console.log(this.emailId);
    }


  }
	  
	  
	  
	
	  
	    sendEmailForm: FormGroup;
  loadSendEmailForm(){
      this.sendEmailForm = this.fb.group({
        'toAddress': ['', [Validators.required, this.commaSepEmail]]
      });
    }
  
    send(value) {
      console.log(value);
    }
  
    commaSepEmail = (control: AbstractControl): { [key: string]: any } | null => {
      const emails = control.value.split(',');
      const forbidden = emails.some(email => Validators.email(new FormControl(email)));
      console.log(forbidden);
      return forbidden ? { 'toAddress': { value: control.value } } : null;
    };
	
	
	 sendForwordEmailOpen() {
    this.loadSendEmailForm();
    $('#sendForwordemail').focus();

  }

	 
  forwordEmailEnter(sendForwordemail,form:NgForm) {
    $('#multipleForwordBtn').focus();
    this.multipleForword(sendForwordemail,form);
  }
  sendMailClose(form:NgForm) {
    $('#sendForwordemail').val('');
    this.emailId = "";
   
  }

  TrashClick(id, status) {
    if (status == 'ViewModal') {
      $("#ViewModal").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
    }

    this._trashService.TrashUndo(id)
      .subscribe((response) => {
        info_noti("Undo Success...")
        this.GetTrash_Grid();
      });
  }
  

  //Delete
  DeleteTrash(id: any, status) {

    debugger;
    if (status == 'ViewModal') {
      $("#ViewModal").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
    }
    this._approvedService.Delete_Trash(id)
      .subscribe((response) => {
        debugger;
        info_noti('Deleted Success...');
        //  info_noti('Deleted Success...');
        this.GetTrash_Grid();
        window.location.reload();

      }, err => {
        info_noti('err');
      });
  }
  //multiple delete
  multipleDelete() {
    debugger;
    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.selectedActionList[i] = this.appvar;
    }
    this._approvedService.Delete_TrashMultiple(this.selectedActionList).subscribe((response) => {
      info_noti('Deleted Success...');
      this.selectedMailList.length = 0;
      this.appvar
      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        this.approvedObjActionShow = null;
        this.checkClickCount = 0;
        this.showActions = false;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetTrash_Grid();
      window.location.reload();
    }, error => { info_noti(error); }
    );
    console.log(this.selectedMailList);
  }


  downloadFile(path) {
    window.open(path, '_self');
  }

  //browser back button or mobile back button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {

    $("#ViewModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#sendEmailForMultipleForword").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

}
